import { isAdmin, isTrialPlan } from '@/service/user'
import { of } from 'rxjs'
import { pluck, filter, map, tap } from 'rxjs/operators'
import resources from '@/store/modules/resources.js'
const moment = require('moment')

const hasTrialMessage = expirations => {
  return expirations && 'daysLeft' in expirations
}

const canSeeTrialMessage = () => {
  const currentDate = moment().format('DD-MM-YY')
  const lastView = localStorage.getItem('notification.expiration.lastView')
  const sameDate = currentDate === lastView

  const isTrialAndAdmin = isTrialPlan() && isAdmin()

  return !sameDate && isTrialAndAdmin
}

const getTrialMessage = expirations => {
  const text = getText(expirations)
  const message = {
    text,
    status: 'warning',
    classes: 'alert-message-expiration',
    dismissClick: function() {
      setTrialMessageAsRead()
    },
    button: {
      text: trialExpiration().button,
      show: true,
      classes: 'btn btn-assign-now',
      click: function() {
        setTrialMessageAsRead()
        this.$root.$emit('app:message:hide')
        this.$router.push({ name: 'account.details' })
        this.$root.$emit('track', {
          event: "Clicou em 'Assine agora' na barra superior",
          data: { category: 'App' },
        })
      },
    },
    ignoreBeforeTransition: true,
  }

  return message
}

const getText = expirations => {
  const { daysLeft } = expirations
  const isPlural = daysLeft > 1
  const {
    messageOnePlural,
    messageTwoPlural,
    messageOneSingular,
    messageTwoSingular,
  } = trialExpiration()

  return `${!isPlural ? messageOneSingular : messageOnePlural} ${daysLeft} ${
    !isPlural ? messageTwoSingular : messageTwoPlural
  }`
}

const setTrialMessageAsRead = lastView => {
  lastView = lastView || moment().format('DD-MM-YY')
  localStorage.setItem('notification.expiration.lastView', lastView)
}

const trialExpiration = () =>
  resources.state.resources.general.message.trialExpiration

export const showTrialMessage = emit => notifications => {
  const notifications$ = of(notifications)
  notifications$
    .pipe(
      pluck('expirations'),
      filter(hasTrialMessage),
      filter(canSeeTrialMessage),
      map(getTrialMessage),
      tap(emit)
    )
    .subscribe()

  return notifications$
}
